import { render, staticRenderFns } from "./CustomersPendingScheduleBatch.vue?vue&type=template&id=80265aec&"
import script from "./CustomersPendingScheduleBatch.vue?vue&type=script&lang=js&"
export * from "./CustomersPendingScheduleBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VDataTable,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/home/forge/demo.ec-direct.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80265aec')) {
      api.createRecord('80265aec', component.options)
    } else {
      api.reload('80265aec', component.options)
    }
    module.hot.accept("./CustomersPendingScheduleBatch.vue?vue&type=template&id=80265aec&", function () {
      api.rerender('80265aec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/CustomersPendingScheduleBatch.vue"
export default component.exports